<div *ngIf="filter"
     class="ng-filters-item"
     [class.open]="isOpen">
    <div class="ng-filters-divider"></div>
    <div class="ng-item-toggle" (click)="toggleHeader()">
        <span class="ng-item-toggle__title">{{ filter.name }}</span>
        <button
            *ngIf="hasSelectedFilter()"
            type="button"
            class="ng-item-toggle__reset"
            (click)="resetFilter($event)"
        >
            Сбросить
        </button>
    </div>
    <div class="ng-item-content">
        <div class="ng-checkbox-list">
            <div *ngFor="let value of visibleValues; trackBy: trackByFn"
                 class="ng-checkbox"
                 (click)="toggleValue(filter.filterKey, value, $event)">
                <ng-container [ngSwitch]="filter.filterKey">
                    <ng-template ngSwitchCase="stars">
                        <app-filter-stars [isActive]="isActive(filter.filterKey, value)"
                                          [filterValue]="value.filterValue"
                                          [viewValue]="value.viewValue"
                                          [count]="value.count"></app-filter-stars>
                    </ng-template>

                    <ng-template ngSwitchDefault>
                        <app-filter-default [isActive]="isActive(filter.filterKey, value)"
                                            [filterValue]="value.filterValue"
                                            [viewValue]="value.viewValue"
                                            [hideCount]="filter.filterKey === 'onlyRecommendedHotels'"
                                            [count]="value.count"></app-filter-default>
                    </ng-template>
                </ng-container>
            </div>
        </div>
        <button *ngIf="filter.values.length > visibleValuesLimit"
                type="button"
                class="ng-filter-show-more"
                [class.down]="showAllValues"
                [attr.aria-expanded]="showAllValues"
                (click)="showAllValues = !showAllValues">
            {{ showAllValues ? messages.showLess : messages.showMore + ' ' + (filter.values.length - visibleValuesLimit) }}
        </button>
    </div>
</div>
